"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeStarredMessageAdapter = void 0;
const sample_data_1 = require("@home-health-notify/sample-data");
/* eslint-disable @typescript-eslint/no-unused-vars */
class FakeStarredMessageAdapter {
    fetchStarredMessages(data, organizationId) {
        return Promise.resolve(sample_data_1.starredMessagesData.data);
    }
}
exports.FakeStarredMessageAdapter = FakeStarredMessageAdapter;
